import { render, staticRenderFns } from "./admin.smartwatches.page.vue?vue&type=template&id=87a41a46&scoped=true&"
import script from "./admin.smartwatches.page.vue?vue&type=script&lang=js&"
export * from "./admin.smartwatches.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.smartwatches.page.vue?vue&type=style&index=0&id=87a41a46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a41a46",
  null
  
)

export default component.exports